import { LitElement, classMap, css, html } from '@lit'
import { t } from '@nova/utils'

class NovaWishlistButton extends LitElement {
  static properties = {
    _active: {
      state: false,
    },
  }

  constructor() {
    super()
    this.onClick = this.onClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this.setAttribute('role', 'button')
    if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0')
    if (!this.hasAttribute('aria-label')) {
      this.setAttribute(
        'aria-label',
        t('accessibility.add_to_wishlist', 'Add to wishlist'),
      )
    }
    this.setAttribute('aria-pressed', String(Boolean(this._active)))
    this.addEventListener('click', this.onClick)
    this.addEventListener('keydown', this.onKeydown)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick)
    this.removeEventListener('keydown', this.onKeydown)
    super.disconnectedCallback()
  }

  onClick(e) {
    e.preventDefault()

    this._active = !this._active
    this.setAttribute('aria-pressed', String(this._active))
  }

  onKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return
    e.preventDefault()
    this.click()
  }

  render() {
    return html` <div class=${classMap({ 'is-active': this._active })}>
      <slot></slot>
    </div>`
  }

  static styles = css`
    :host {
      width: 25px;
      height: 25px;
      display: block;
      position: absolute;
      top: 1em;
      right: 1em;
      z-index: 2;
    }
    :host(:hover) {
      cursor: pointer;
    }
    ::slotted(svg) {
      transition: fill var(--nova-transition, 400ms) ease;
      fill: white;
    }
    .is-active ::slotted(svg) {
      fill: red;
    }
  `
}

customElements.define('nova-wishlist-button', NovaWishlistButton)
